import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';

export const useNoteCategory = (categoryId: number | undefined): string => {
  const categories = useAppSelector(
    referenceSlice.selectProviderNoteCategories,
  );
  const category = categories.find(
    (c) => c.providerNoteCategoryID === categoryId,
  );
  return category ? category.providerNoteCategoryName : '';
};
